import Map from 'ol/Map.js';
import OSM from 'ol/source/OSM.js';
import View from 'ol/View.js';
import Point from 'ol/geom/Point.js';
import Feature from 'ol/Feature.js';
import Overlay from 'ol/Overlay.js';
import {Icon, Style, Fill, Stroke, Text} from 'ol/style.js';

import {Tile as TileLayer} from 'ol/layer.js';
import {Circle as CircleStyle} from 'ol/style.js';
import {Vector as VectorLayer} from 'ol/layer.js';
import {Cluster, Vector as VectorSource} from 'ol/source.js';

let map = new Map({
  layers: [
    new TileLayer({source: new OSM()})
  ],
  target: document.getElementById('map'),
  view: new View({
    projection: 'EPSG:4326',
    center: [12.479234, 41.894968],
    zoom: 6
  })
});

let companies = [
  {
    name: 'Optit',
    website: 'https://www.optit.net',
    lat: 44.155961, 
    lon: 12.242582,
    location: 'Cesena',
    logo: 'img/optit.png'
  },
  {
    name: 'Optit',
    website: 'https://www.optit.net',
    lat: 44.488553,
    lon: 11.361833,
    location: 'Bologna',
    logo: 'img/optit.png'
  },
  {
    name: 'Optrail',
    website: 'http://www.optrail.com',
    lat:  41.873965,
    lon: 12.487413,
    location: 'Roma',
    logo: 'img/optrail.png'
  },
  {
    name: 'Circle',
    website: 'https://www.circletouch.eu',
    lat: 44.411994,
    lon: 8.884744,
    location: 'Genova',
    logo: 'img/circle.png'
  },
  {
    name: 'Consorzio C2T',
    website: 'http://www.consorzioc2t.it/en/',
    lat: 45.673118,
    lon: 9.220601,
    location: 'Milano',
    logo: 'img/c2t.png'
  },
  {
    name: 'Consorzio C2T',
    website: 'http://www.consorzioc2t.it/en/',
    lat: 37.516710,
    lon: 15.082801,
    location: 'Catania',
    logo: 'img/c2t.png'
  },
  {
    name: 'Fleetmatics',
    website: 'https://www.verizonconnect.com/company/careers/',
    lat: 43.781944,
    lon: 11.231284,
    location: 'Firenze',
    logo: 'img/verizon-connect.png'
  },
  {
    name: 'MAIOR',
    website: 'https://www.maior.it/it',
    lat: 43.837945,
    lon: 10.488355,
    location: 'Lucca',
    logo: 'img/maior.png'
  },
  {
    name: 'Actor',
    website: 'http://www.actorventure.com/',
    lat: 41.890983,
    lon: 12.503638,
    location: 'Roma',
    logo: 'img/actor-old.png'
  },
  {
    name: 'Esteco',
    website: 'https://www.esteco.com/',
    lat: 45.657979,
    lon: 13.829090,
    location: 'Trieste',
    logo: 'img/esteco.png'
  },
  {
    name: 'Kantar',
    website: 'https://consulting.kantar.com/',
    lat: 44.484333,
    lon: 11.262365,
    location: 'Bologna',
    logo: 'img/kantar.png'
  },
  {
    name: 'Consorzio MR',
    website: 'http://www.milanoricerche.it/',
    lat: 45.510916,
    lon: 9.212270,
    location: 'Milano',
    logo: 'img/milano-ricerche.png'
  },
  {
    name: 'IROI',
    website: 'http://www.iroi.it/',
    lat: 44.387399,
    lon: 9.006530,
    location: 'Genova',
    logo: 'img/iroi.jpg'
  },
  {
    name: 'AutoLogS',
    website: 'http://www.autologs.eu/en/index.html',
    lat: 41.157798,
    lon: 16.772653,
    location: 'Bari',
    logo: 'img/autologs.png'
  },
  {
    name: 'ACT-OR',
    website: 'https://www.act-operationsresearch.com/',
    lat: 42.102281,
    lon: 12.635553,
    location: 'Roma',
    logo: 'img/actor.png'
  }
];

companies.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)); 

let markers = [];
let addedCompanies = [];

for(let company of companies) {
  let marker = new Feature({
    geometry: new Point([company.lon, company.lat]),
    text: '<a href="' + company.website + '">' + company.name + '</a><br>' + company.location
  });

  marker.setStyle(new Style({
    image: new Icon(({
      crossOrigin: 'anonymous',
      src: 'img/marker.png',
      scale: 0.15,
      anchor: [0.5, 256],
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
    }))
  }));

  markers.push(marker);

  let compactName = company.name.replace(/\s/g, '').toLowerCase();

  if(!addedCompanies.includes(company.name)) {
    let companyCard =
      '<div id="card-' + compactName + '" class="card m-1 d-inline-block h-100" style="max-width: 240px; width: 240px;">' +
        '<div class="row no-gutters">' +
          '<div class="col-md-4 align-self-center">' +
            '<img src="' + company.logo + '" class="card-img">' +
          '</div>' +
          '<div class="col-md-8">' +
            '<div class="card-body">' +
              '<p class="card-text">' +
                '<a href="' + company.website + '">' + company.name + '</a>' + 
                '<br><small class="text-muted">' + company.location + '</small>' +
              '</p>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';

    let cardsContainer = document.getElementById('company-cards');
    cardsContainer.insertAdjacentHTML('beforeend', companyCard);

    addedCompanies.push(company.name);
  } else {
    let locationText = $('#card-' + compactName + ' div p small.text-muted');

    if(locationText.length != 1) {
      console.error('Expecting exactly one text element, found ' + locationText.length);
    }

    locationText.append(', ' + company.location);
  }
}

let vectorSource = new VectorSource({
  features: markers
});

let markerVectorLayer = new VectorLayer({
  source: vectorSource
});

map.addLayer(markerVectorLayer);

let popup = document.getElementById('popup');
let popupOver = new Overlay({
  element: popup,
  positioning: 'top-center',
  stopEvent: false,
  offset: [0, -25]
});

map.addOverlay(popupOver);

map.on('click', function(e) {
  let ftr = map.forEachFeatureAtPixel(e.pixel, function(f) { return f; });

  if(ftr) {
    let coords = ftr.getGeometry().getCoordinates();

    $(popup).popover('dispose');

    popupOver.setPosition(coords);

    $(popup).popover({
      placement: 'top',
      html: true,
      content: ftr.get('text')
    });

    $(popup).popover('show');
  } else {
    $(popup).popover('dispose');
  }
});

map.on('pointermove', function(e) {
  if (e.dragging) {
    $(popup).popover('dispose');
    return;
  }

  let pixel = map.getEventPixel(e.originalEvent);
  let hit = map.hasFeatureAtPixel(pixel);

  map.getTarget().style.cursor = hit ? 'pointer' : '';
});